module.exports = __webpack_public_path__ + "static/copay_img-7a14dd05f156d15e5f568b51bdd9ca90.png";